import React from 'react';
import GrayCardMember from '../../../components/GrayCardMember';
import GrayCardMemberExcess from '../../../components/GrayCardMemberExcess';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import './BHVerifiedData.css';
import { Row, Col, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import {
    getCardsDataForIMARKVerifiedDataTab,
    getVerifiedRebateTrendsGraph, getbHverifiedVendorPartnerPurchases,
    getMemberBranch, getMemberVerifiedMonthsFilter,tabTracking
} from '../../../actions';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';
import Modal from '../../../components/Modal';
import { getCardTitle, PriceFormatter1, dynamicDateFilters1, PercentFormatter1,monthName1, monthName, jsonToParam, paramsToJSON, paramsToJSON1, DateFormatter, PercentFormatter } from '../../../helper';
import accounting from 'accounting-js';
// import 'semantic-ui-css/semantic.min.css';
import _isEqual from 'lodash/isEqual';
import ReactExport from "react-export-excel";
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { PriceFormatter } from '../../../helper';
import { differenceFormatter } from '../../../helper';
import { matLoader } from '../../../components/Loader';
import MembershipQualification from './membership-qualification';
import MembershipQualificationWireframe from '../VerifiedData/wireframe';
import Axios from 'axios';
import { ROOT_URL } from '../../../actions';

class BHVerifiedData extends React.Component {
    state = {
        selectedFilter: "YTD",
        buttonOptions: ["MTH", "YTD", "QTR"],
        showQuarter: false,
        BranchNames: [],
        dataval: [],
        items: [],
        selectedBranch: "All Branch Summary",
        selectedYear: new Date().getFullYear(),
        selectedItem: new Date().getMonth(),
        isLoading: true,
        listOfRebates: ["Quarterly Flat", "Order Discount", "Conversion", "EDI", "Special Promo", "PrimeTime 1Q19 only", "BuyBLUE", "Warranty", "Adjustments to Prior Year"],
        refreshData: true,
        params: {
            period: "YTD",
            ytd: "true",
            qtr: "false",
            mth: "false",
            year: 2022,
            month: 12,
            quarter: 1,
            "memberId": this.props.memberIdForCorporate,
            "buyingGroupId": this.props.buyingGroupId,
            "dropDown": [],
            "rebate": ""
        },

        excessRender: false,
        excessRenderFalse: false,
        expanded: false,
        chartTitle: {
            show: false,
            text: 'Volume vs Rebate Earned (VP Quarterly Data)',
        },
        chartTitle2: {
            show: false,
            text: 'Rebate Earned 2018 vs Rebate Earned 2019 (VP Quarterly Data)',
        },
        displayModal: false,
        propsForModal: {

        },
        rebateCardData: [],
        overallCardData: [],
    }
    handleUserSelectedFilter(option) {
        let obj = {};
         
        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }
       
    let paramsValues = this.state.params;
    let paramsfinal = paramsToJSON1(paramsValues);
    let month = paramsfinal.month;
    if(month >= 1 && month <= 3){
        paramsfinal.quarter= 1
    }
    else if(month >= 4 && month <= 6){
        paramsfinal.quarter = 2
    }
    else if(month >= 7 && month <= 9){
        paramsfinal.quarter = 3
    }
    else if(month >= 10 && month <= 12){
        paramsfinal.quarter = 4
    }
    
    let params = jsonToParam(paramsfinal);
            this.setState({ selectedFilter: option,params: params}, () => {
            this.setFilter({ period: this.state.selectedFilter, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }

    componentWillMount() {

        let paramsValues = this.state.params;
        if (paramsValues.buyingGroupId === "1") {
            this.setState({ excessRender: true })
        }
        else {
            this.setState({ excessRenderFalse: true })
        }
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });

    }

    componentDidMount() {
        console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptions: ["YTD", "QTR"], selectedFilter: "YTD" });
        }
        let paramsValues = this.state.params;
        paramsValues = paramsToJSON(paramsValues);
        Axios.get(ROOT_URL + '/compliant?memberId=' + (paramsValues.memberId))
        .then(resp => this.setState
            ({ 
                compliantvalue: resp.data ,
                addModalShow1: !resp.data,
                addModalShow: !resp.data && !sessionStorage.getItem('flag')
            }));
            let params = jsonToParam(paramsValues);
        Promise.all([
            this.props.getMemberVerifiedMonthsFilterAPI(this.state.params),
            this.props.getMemberBranchAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=4"),
            // this.props.getVerifiedRebateTrendsGraphAPI(this.state.params),
            // this.props.getbHverifiedVendorPartnerPurchasesAPI(this.state.params),
            // this.props.getCardsDataForIMARKVerifiedDataTabAPI(this.state.params),

        ]).then(data => {
            this.getOptions();
            this.getOptionsYear();
            this.getBranchList();
            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
           // window.location.reload();

        })
        let checkStorage = localStorage.setItem('flag','11')
        setTimeout(function () { localStorage.removeItem("flag"); }, 5000);

    }
    componentWillReceiveProps(props) {
        console.log('this is will recieve props ', props);
        const { refreshData, dataForChart1, dataForChart2 } = this.state;
        if (refreshData) {
            this.setState({
                dataForChart1: {
                    data: {
                        columns: [
                            props.getVerifiedRebateTrendsGraph.chartData1,
                            props.getVerifiedRebateTrendsGraph.chartData2,
                        ],
                        axes: {
                            data1: 'y',
                            data2: 'y2'
                        },
                    }
                },
                dataForChart2: {
                    data: {
                        columns: [
                            props.getVerifiedRebateTrendsGraph.chartData2,
                            props.getVerifiedRebateTrendsGraph.chartData3,
                        ],
                        axes: {
                            data2: 'y',
                            data3: 'y2'
                        },
                    }
                }
            });
        }

    }

    closeModal = () => {
        this.setState({ displayModal: false });
    }
    displayModal() {
        if (this.state.displayModal === true) {
            // render table or card according to modaltype

            return (
                <Modal parentView="BHVerified" width="800px" modalType="table" propsForModal={this.state.propsForModal} closeModal={this.closeModal} />
            )
        } else {
            return (
                <div className="modal fade" tabIndex="-1" role="dialog">

                </div>
            )
        }
    }
    displayModalMethod = (propsForModal) => {
        console.log('setting true', propsForModal);
        this.setState({ displayModal: true, propsForModal: propsForModal });
    }

    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
                let obj = {};
                obj[event.name] = event.value;
                params.quarter = event.value;
                let quarter = params.quarter
                params = jsonToParam(params);
                this.setState({
                    quarter:quarter,
                    params: params})
                this.setState(obj, () => {
                    this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
                });
        
            }

    handleChangeOfDropdownYear(e) {
       
        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        let items =[]
        params.year = e.value
        year = params.year
        let selectedYear = { label: year, value: year }
        // let memberId=params.memberId;
        let dataval = Object.keys(this.props.getMemberVerifiedMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })

        let selectedYear1 = yearval[yearval.length - 1];
        // if (selectedYear1.value != 2023 && e.value == 2023 )
            if (selectedYear1.value != 2024 && e.value == 2024 )
        {
            items = [{ label: monthName1(1),value: 1}];
        }
        else {
        let dataval1 = Object.values(this.props.getMemberVerifiedMonthsFilter[year]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }
        }
        
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
            items: items,
            selectedItem : selectedItem,
        },this.getBranchList)

        let allmemberArr1 = [];
        
        let BranchNameObj = [];

        this.props.getMemberBranchAPI(params).then(res => {

            let memberId = ''
            res.map((data, index) => {
                allmemberArr1.push(_get(data, 'branchId', ''));
            })
            BranchNameObj = res.map((data, index) => {
                return {
                    // key: index,
                    label: data.branchId + "--" + data.branchName,
                    value: data.branchId
                }
            })
            
            // memberId = allmemberArr1[0];

            BranchNameObj.unshift({ label: "All Branch summary", value: this.props.allmemberArr1 });
            let selectedBranch = BranchNameObj[0]
            params = paramsToJSON(params);
            params.memberId = BranchNameObj[0].value;
            memberId = params.memberId
            params.month = this.state.selectedItem.value;
            month = params.month
            if (month >= 1 && month <= 3) {
                params.quarter = 1
            }
            else if (month >= 4 && month <= 6) {
                params.quarter = 2
            }
            else if (month >= 7 && month <= 9) {
                params.quarter = 3
            }
            else if (month >= 10 && month <= 12) {
                params.quarter = 4
            }
            params = jsonToParam(params);
        
        this.setState({
            BranchNames: BranchNameObj,
                params: params,
                selectedYear: selectedYear,
                items: items,
                selectedItem : selectedItem,
                selectedBranch: selectedBranch,
                month: month
        })
        
        this.setState(e, () => {
            this.setFilter({ year: this.state.year, memberId: memberId, selectedYear: selectedYear,selectedItem:selectedItem });
        });
    })

    }
    getOptionsYear() {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        let dataval = Object.keys(this.props.getMemberVerifiedMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear = yearval[yearval.length - 1];
        params.year = selectedYear.value
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            else if (selectedYear.value != 2023 && selectedYear.value != 2024){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
        }
         //add this new code
         else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
        
        params = jsonToParam(params)
        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
            params: params,
        })
        
    }
    getOptions() {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        let items = []
        let dataval = Object.keys(this.props.getMemberVerifiedMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];

        let dataval1 = Object.values(this.props.getMemberVerifiedMonthsFilter[selectedYear1.value]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }

        if (selectedYear1.value != 2022)
        {
        yearval.push({ label: 2022, value: 2022 });
        }
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        params.year = selectedYear1.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params,
        })
        
    }

    getBranchList() {
        let params = this.state.params;
        params = paramsToJSON(params);
        let BranchNames = [];
        let BranchNameObj = [];
        BranchNameObj = this.props.getMemberBranch.map((vname, index) => {
            return {
                // key: index,
                label: vname.branchId + "--" + vname.branchName,
                value: vname.branchId
            }
            // BranchNames.push(BranchNameObj)
        })
        BranchNameObj.unshift({ label: "All Branch summary", value: this.props.allmemberArr1 });
        let selectedBranch1 = BranchNameObj[0];
        params.memberId = selectedBranch1.value;
        params = jsonToParam(params)
        this.setState({
            BranchNames: BranchNameObj,
            selectedBranch: selectedBranch1,
            params: params
        })
        this.props.getMemberBranchAPI(params)
        this.props.getCardsDataForIMARKVerifiedDataTabAPI(params)
        this.props.getVerifiedRebateTrendsGraphAPI(params)
        this.props.getbHverifiedVendorPartnerPurchasesAPI(params)

    }

    renderButtonGroup() {

        return this.state.buttonOptions.map((option, index) => {
            return (
                <button  style ={{height:'38px'}} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilter === option) ? "active" : null}`}>{option}</button>
            )
        })
    }

    handleClickBranch = (e) => {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let selectedBranch = { label: e.label, value: e.value }
        let arr = [];
        let valstr = [e.value];
        if (valstr != "" && valstr != "undefined") {
            // let valueee = valstr.map((option, index) => {
            // let val = _find(value.options, ['value', option])
            arr.push(valstr)
            // })
            params.memberId = arr
        }
        else {
            params.memberId = this.props.memberIdForCorporate

        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedBranch: selectedBranch,
        })


        this.props.getCardsDataForIMARKVerifiedDataTabAPI(params)
        this.props.getVerifiedRebateTrendsGraphAPI(params)
        this.props.getbHverifiedVendorPartnerPurchasesAPI(params)


    }

    handleChangeOfDropdownMonth = (e) => {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month

        let selectedItem = { label: monthName1(month), value: month }
        
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })

        this.props.getCardsDataForIMARKVerifiedDataTabAPI(params)
        this.props.getVerifiedRebateTrendsGraphAPI(params)
        this.props.getbHverifiedVendorPartnerPurchasesAPI(params)


    }


    setFilter = (filter) => {
        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            // params.quarter = filter.quarter;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {
            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            // params.month = filter.month;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            // params.year = filter.year;
            // params.month = filter.month;
            params.period = filter.period;
        }
        else if (filter.memberId != undefined) {
            params.memberId = filter.memberId;

        }
        else if (filter.year != undefined) {
            // params.quarter = filter.quarter;
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            refreshData: true,
            isLoading: true
        }, () => Promise.all([
            this.props.getCardsDataForIMARKVerifiedDataTabAPI(this.state.params),
            this.props.getVerifiedRebateTrendsGraphAPI(this.state.params),
            this.props.getbHverifiedVendorPartnerPurchasesAPI(this.state.params),

        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))

    }

    TierComponent = (cell, rows) => {
        let tier = _get(rows, 'tier', "")
        if (tier) {
            return <div className="tier">{tier}</div>
        }
    }

    AttainmentComp = (cell, rows) => {

        let percentAttained = _get(rows, 'attaintment', 0);
        if (percentAttained >= 100) {
            return (
                <div className={"attainmentGreen"}>{Number(percentAttained).toFixed(1)}</div>
            )
        } else if (percentAttained >= 75 && percentAttained < 100) {
            return (
                <div className={"attainmentYellow"}>{Number(percentAttained).toFixed(1)}</div>
            )
        }
        else if (percentAttained >= 0 && percentAttained < 75) {
            return (
                <div className={"attainmentRed"}>{Number(percentAttained).toFixed(1)}</div>
            )
        }

    }
    complintNonComplient = (cell, rows) => {
        //;
        let CompNonComp = _get(rows, 'isCompliant', 0);
        //
        if (CompNonComp === false) {
            return (
                <OverlayTrigger overlay={(<Tooltip id="hi">The Supplier in Non Compliant</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="noncompliant">{<i class="fas fa-angle-right" style={{ size: '7px' }} ></i>}</div>
                </OverlayTrigger>
            )
        }
        else if (CompNonComp === true) {
            return (
                <OverlayTrigger overlay={(<Tooltip id="hi">The supplier is Compliant</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="compliant" >{<i class="fas fa-angle-right"></i>}</div>
                </OverlayTrigger>
            )
        }

    }

    renderGrowthTiers = (rebateProgram, growthTier) => {
        console.log('Rendering Tiers', growthTier);
        let variant = 'success';
        let minimumAttainment = Math.min.apply(null, Array.from(growthTier.rebateTierCriteria.map(tierCriteria => tierCriteria.attainmentPercent)));
        if (minimumAttainment <= 50) {
            variant = 'danger';
        } else if (minimumAttainment < 100) {
            variant = 'warning';
        }
        return (
            <OverlayTrigger overlay={(<Tooltip>{
                <React.Fragment>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>{rebateProgram.programName}</div>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Tier: {growthTier.tier}</div>
                    {growthTier.rebateTierCriteria.map((criteria, index) => {
                       
                        return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                            <div>Criteria {(index + 1) + ': ' + criteria.criteria}</div>
                           
                          {/* <div>Condition : {PriceFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div> */}
                            <div>Target : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.target).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.target)}</div>
                            <div>Actual : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.actual).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.actual)}</div>
                            {/* <div>Growth : {PriceFormatter1(criteria.requiredGrowth)}</div> */}
                            <div>Gap : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.gap).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.gap)}</div>
                            <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                        </div>
                    })}
                        
                </React.Fragment>
            }</Tooltip>)}
                popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
                <Col style={{ 'padding': '1px' }}><div className={'bg-' + variant} style={{ 'width': '100%', 'height': '15px' }}></div></Col>
            </OverlayTrigger>
            // END COL
        )
    };

    GrowthTier = (cell, rows) => {
        //
        console.log('Growth Rebate', rows.growthRebate);
        if (rows.growthRebate && rows.growthRebate.length > 0) {
            return <React.Fragment>{rows.growthRebate.map(rebateProgram =>
                <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {rebateProgram.rebateTier.map(programTiers => this.renderGrowthTiers(rebateProgram, programTiers))}
                </Row>)
            }</React.Fragment>;
        } else {
            return <div></div>;
        };
    };

    GrowthTierIndividual= (cell, rows) => {
        //
        console.log('Growth Rebate', rows.individualGrowthRebate);
        if (rows.individualGrowthRebate && rows.individualGrowthRebate.length > 0) {
            return <React.Fragment>{rows.individualGrowthRebate.map(rebateProgram =>
                <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {rebateProgram.rebateTier.map(programTiers => this.renderGrowthTiers(rebateProgram, programTiers))}
                </Row>)
            }</React.Fragment>;
        } else {
            return <div></div>;
        };
    };

    renderConversionOpportunity() {
        let params = this.state.params;
        params = paramsToJSON(params);
        // const { terminatedVpOppConversionOpp } = this.props;
        this.getbHverifiedVendorPartnerPurchase = [];
        return (
            <div className="">
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        {/* <div className="card-header">
                Purchase within IMARK
                            </div> */}
                        <div className="card-body">
                            <h5 style={{ textDecorationLine: 'underline', }}>Purchase within IMARK</h5>

                            <BootstrapTable height='350' search data={this.props.getbHverifiedVendorPartnerPurchases} striped hover version="4">
                                <TableHeaderColumn thStyle={{backgroundColor: '#ccc' ,position: 'sticky', left: 0, zIindex: 1 }} tdStyle = {{backgroundColor: '#ccc' ,position: 'sticky', left: 0, zIindex: 1 }} width="50px" dataSort={true} dataFormat={this.complintNonComplient} dataField='isCompliant'></TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal',backgroundColor: '#ccc' ,position: 'sticky', left: 0, zIindex: 1 }} tdStyle={{ whiteSpace: 'normal',backgroundColor: '#ccc' ,position: 'sticky', left: 0, zIindex: 1 }} width="140px" dataSort={true} isKey dataField='vendorName'>Supplier Name</TableHeaderColumn>
                                {/* <TableHeaderColumn row='0' thStyle={{ whiteSpace: 'normal' }} tdStyle={ { whiteSpace: 'normal' } }colSpan='2'>Product</TableHeaderColumn>
                 */}
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataFormat={DateFormatter} dataField='updateDateVendorData'>Supplier Date</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="100" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={monthName1} dataField='updateDateImarkVerified'>Verified Date </TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataField='purchaseAmountVendorData' dataFormat={PriceFormatter}>Supplier Purchase</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataField='purchaseAmountImarkVerified' dataFormat={PriceFormatter}>Verified Purchases</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataField='rebateEarnedVendorData' dataFormat={PriceFormatter}>Supplier Earned</TableHeaderColumn>

                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataField='rebateEarnedImarkVerified' dataFormat={PriceFormatter}>Verified Earned</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataField='rebateReceivedImarkVerified' dataFormat={PriceFormatter}>Rebate Recieved</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="160" dataSort={true} dataFormat={this.GrowthTier} datafield="growthRebate"> Group Growth</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataFormat={PriceFormatter} dataField='estimatedGrowthRebate'>Estimated Group Growth Rebate</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="160" dataSort={true} dataFormat={this.GrowthTierIndividual} datafield="individualGrowthRebate">Individual Growth</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataFormat={PriceFormatter} dataField='estimatedIndividualGrowthRebate'>Individual Estimated Growth Rebate</TableHeaderColumn>
                              
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="100" dataSort={true} dataFormat={PriceFormatter} dataField='estimatedGainShare'>Estimated Gain Share</TableHeaderColumn>

                                {/* <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="100px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='vendorName'> Supplier Name</TableHeaderColumn>
                    <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="20px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='updateDateVendorData'>Supplier Date</TableHeaderColumn>
                    <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="40px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='updateDateImarkVerified'>Verified Date</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="50px" dataSort={true} dataField='purchaseAmountVendorData' dataFormat={PriceFormatter}>Total Purchase</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true} dataField='purchaseAmountImarkVerified' dataFormat={PriceFormatter}>Total Purchases</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true} dataField='rebateEarnedImarkVerified' dataFormat={PriceFormatter}>Rebate Earned</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true} dataField='rebateEarnedVendorData' dataFormat={PriceFormatter}>Rebate Earned</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true} dataField='rebateReceivedImarkVerified' dataFormat={PriceFormatter}>Rebate Recieved</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true}  dataFormat={this.ProgressBarforGrowth}  dataField=''> Growth</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true} dataField=''>Estimated Growth Rebate</TableHeaderColumn>
                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40px" dataSort={true} dataField='estimatedGainShare'>Estimated Gain Share</TableHeaderColumn>  */}
                            </BootstrapTable>
                        </div>
                        <div class="card-footer" style={{ textAlign: 'center' }}>
                            All Records Are YTD Till {monthName1(this.state.selectedItem.label)}, {params.year}
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    render() {
        // let dataForChart2 = {
        //     data: {
        //         x: 'x',

        //         columns: [

        //             ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

        //             this.props.getVerifiedRebateTrendsGraph.chartData2,
        //             this.props.getVerifiedRebateTrendsGraph.chartData3,

        //         ],
        //         axes: {
        //             data1: 'y',
        //             data2: 'y2'
        //         },
        //         names: {
        //             data2: "Rebate Earned ($)",
        //             data3: "Total Rebate Recieved ($)"
        //         }
        //     },
        //     axis: {
        //         x: {
        //             label: "Months",
        //             type: 'category'
        //         },
        //         y: {
        //             // label:"Total Volume",
        //             tick: {
        //                 format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
        //                 //                format: function (d) { return "$" + d; }
        //             }
        //         },
        //         y2: {
        //             label:"Rebate Earned",
        //             show: true,
        //             tick: {
        //                 format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
        //                 //                format: function (d) { return "$" + d; }
        //             }
        //         }
        //     }
        // };
        // let dataForChart1 = {
        //     data: {
        //         x: 'x',

        //         columns: [

        //             ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

        //             this.props.getVerifiedRebateTrendsGraph.chartData1,
        //             this.props.getVerifiedRebateTrendsGraph.chartData2,

        //         ],
        //         axes: {
        //             data1: 'y',
        //             data2: 'y2'
        //         },
        //         names: {
        //             data1: "Total Purchase ($)",
        //             data2: "Rebate Earned ($)"
        //         }
        //     },
        //     axis: {
        //         x: {
        //             type: 'category'
        //         },
        //         y: {
        //             tick: {
        //                 format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
        //                 //                format: function (d) { return "$" + d; }
        //             }
        //         },
        //         y2: {
        //             show: true,
        //             tick: {
        //                 format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
        //                 //                format: function (d) { return "$" + d; }
        //             }
        //         }
        //     }
        // }

        let dataForChart2 = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    this.props.getVerifiedRebateTrendsGraph.chartData2,
                    this.props.getVerifiedRebateTrendsGraph.chartData3,

                ],
                axes: {
                    data2: 'y',
                    data3: 'y2'
                },
                names: {
                    data2: "Rebate Earned ($)",
                    data3: "Total Rebate Recieved ($)"
                }
            },
            type: 'bar',
            types: {
                data2: 'bar',
                data3: 'bar',
            },
            axis: {
                x: {
                    label: "Months",
                    type: 'category'
                },
                y: {
                    label: "Total Volume",
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    label: "Rebate Earned",
                    show: false,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        };
        let dataForChart1 = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    this.props.getVerifiedRebateTrendsGraph.chartData1,
                    this.props.getVerifiedRebateTrendsGraph.chartData2,

                ],
                type: 'line',
                types: {
                    data1: 'line',
                    data2: 'line',
                },
                axes: {
                    data1: 'y',
                    data2: 'y2'
                },
                names: {
                    data1: "Total Purchase ($)",
                    data2: "Rebate Earned ($)"
                }
            },
            axis: {
                x: {
                    type: 'category'
                },
                y: {
                    tick: {
                        show: false,
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        }
        const { excessRender, excessRenderFalse } = this.state;
        //overall card section
        let overallCardSection = [];
        this.props.getCardsDataForIMARKVerifiedDataTab.map((card, index) => {
            let str = accounting.formatMoney(card.value);
            str = str.slice(0, -3);
            overallCardSection.push(
                <GrayCardMember
                    displayModal={this.displayModalMethod}
                    closeModal={this.closeModal}
                    type={"amount"}
                    title={getCardTitle(card.cardTitle)}
                    amount={str}
                    date={card.updateDate}
                    growthAmount={card.yoy}
                    growth={card.yoy >= 0 ? "positive" : "negative"}
                />
            )
        })
        if (_isEmpty(overallCardSection)) {
            overallCardSection.push(
                <div className="col-3 errorText">No Data Available</div>
            )
        }

        let overallCardSectionExcess = [];
        this.props.getCardsDataForIMARKVerifiedDataTab.map((card, index) => {
            let str3 = card.value;
            let str = accounting.formatMoney(card.value);
            str = str.slice(0, -3);
            let str1 = accounting.formatMoney(card.lastYearValue);
            str1 = str.slice(0, -3);
            let yoy = '';
            // ;
            if ((card.lastYearValue) != 0) {
                yoy = ((((card.value) - (card.lastYearValue)) / (card.lastYearValue)) * 100)
            } else {
                yoy = 'NA'
            }
            overallCardSectionExcess.push(
                <GrayCardMemberExcess
                    displayModal={this.displayModalMethod}
                    closeModal={this.closeModal}
                    type={"amount"}
                    title={getCardTitle(card.cardTitle)}
                    amount={str}
                    excessRevenue={str3}
                    date={card.updateDate}
                    growthAmount={yoy}
                    growth={yoy >= 0 ? "positive" : "negative"}
                />
            )
        })
        if (_isEmpty(overallCardSectionExcess)) {
            overallCardSectionExcess.push(
                <div className="col-3 errorText">No Data Available</div>
            )
        }

        const { getbHverifiedVendorPartnerPurchases } = this.props;
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        let params = this.state.params;
        params = paramsToJSON(params);
        return (
            <div className="Dashbord" style={{ marginLeft: "60px", marginRight: "60px" }}>
                <nav className="userInfo Filters navbar" style={{ marginLeft: "0px" }}>
                {this.state.addModalShow1 == true ? 
                    <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-memberName')}  ( Non-Compliant Member)</span>
                      :
                    <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-memberName')}  ( Compliant Member)</span>
                    }
                    <div className="export-button-wrapper">
                       

                        <Select autosize={true} id="branchvalue" onChange={(e) => this.handleClickBranch(e)}
                            value={this.state.selectedBranch}
                            options={this.state.BranchNames} />


                        <ul className="navbar-nav flexRowForFilters" >
                            <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                                <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                    value={this.state.selectedYear}
                                    options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control"  style ={{height:'38px',width:'80px'}} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                    <option value="1" selected={ params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={ params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={ params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={ params.quarter == 4 ? true : false} >QTR4</option>
                                    
                                    </select>

                                </li>
                                :
                                <li className = "nav-item">
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true}
                                        value={this.state.selectedItem}
                                        options={this.state.items} />

                                </li>
                            }
                        </ul>

                        <ExcelFile element={<button className="btn btn-primary"  style ={{height:'38px',marginLeft:'4px'}}>Export</button>}>
                            <ExcelSheet data={getbHverifiedVendorPartnerPurchases} name="VendorPartnerVolume">
                                <ExcelColumn label="SUPPLIER NAME" value="vendorName" />
                                <ExcelColumn label="SUPPLIER DATE" value="updateDateVendorData" />
                                <ExcelColumn label="VERIFIED MONTH" value="updateDateImarkVerified" />
                                <ExcelColumn label="SUPPLIER PURCHASE" value="purchaseAmountVendorData" />
                                <ExcelColumn label="VERIFIED PURCHASE" value="purchaseAmountImarkVerified" />
                                <ExcelColumn label="VERIFIED EARNED " value="rebateEarnedImarkVerified" />
                                <ExcelColumn label="SUPPLIER  EARNED" value="rebateEarnedVendorData" />
                                <ExcelColumn label="REBATE RECIEVED" value="rebateReceivedImarkVerified" />
                                {/* <ExcelColumn label="GROWTH" value="growthRebate" />
                                <ExcelColumn label="ESTIMATED GROWTH REBATE" value="estimatedGainShare" />
                                <ExcelColumn label="ESTIMATED GAIN SHARE" value="growthRebate" /> */}

                            </ExcelSheet>
                        </ExcelFile>

                    </div>
                </nav>

                {this.state.isLoading ? matLoader() : <div>

                    {/* <MembershipQualification params={paramsToJSON(this.state.params)} verifiedSource={true} /> */}
                    {params.year < 2021 ?

<MembershipQualification params={paramsToJSON1(this.state.params)} verifiedSource={true} />

: <MembershipQualificationWireframe params={paramsToJSON1(this.state.params)} verifiedSource={true} />}

                    <div>
                        {/* to display modal */}
                        {this.displayModal()}
                        {/* {overallCardSection} */}
                        {excessRender && (
                            <div className="row" style={{ marginTop: "", paddingBottom: "12px", paddingTop: "0", marginLeft: "" }}>
                                {overallCardSectionExcess}
                            </div>
                        )}
                        {excessRenderFalse && (
                            <div className="row" style={{ marginTop: "", paddingBottom: "12px", paddingTop: "0", marginLeft: "" }}>
                                {overallCardSection}</div>
                        )}

                    </div>

                    <div className="row" style={{ paddingBottom: "12px", paddingTop: "0", marginLeft: "0px" }}>
                        <div className="col-6">
                            <div className="card-deck" >
                                <div className="card shadow-sm mb-3">
                                    <div className="card-header">Total Purchases vs Rebate Earned(IMARK Verified)</div>
                                    <div className="card-body">
                                        <div className="chart c3" >
                                            <C3Chart data={dataForChart1.data} axis={dataForChart1.axis} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="card-deck" >
                                <div className="card shadow-sm mb-3">
                                    <div className="card-header">Rebate Earned vs Rebate Recieved(IMARK Verified)</div>
                                    <div className="card-body">
                                        <div className="chart c3" id="topMemberChart">
                                            <C3Chart data={dataForChart2.data} axis={dataForChart2.axis} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-12">
                            {this.renderConversionOpportunity()}
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}
function mapStateToProps(state) {
    let chartDatafor1 = _get(state, 'member.getVerifiedRebateTrendsGraph', []);
    let chartData1Arr = [];
    let chartData2Arr = [];
    let chartData3Arr = [];
    if (!_isEmpty(chartDatafor1)) {
        let chartData1 = chartDatafor1.map((data, index) => {
            chartData1Arr.push(_get(data, 'totalPurchases', ''));
            chartData2Arr.push(_get(data, 'rebateEarned', ''));
            chartData3Arr.push(_get(data, 'rebateReceived', ''));
        })
    }
    chartData1Arr.unshift('data1');
    chartData2Arr.unshift('data2');
    chartData3Arr.unshift('data3');
    // ;
    //     let membergrowth = _get(state, 'member.getbHverifiedVendorPartnerPurchases', []);
    //     let membergrowthArr = [];
    //     if (!_isEmpty(membergrowth)) {
    //         membergrowth.map((data, index) => {
    //             membergrowthArr.push(_get(data, 'growthRebate.gap', ''));
    //          })
    //     }
    //     else {
    //         membergrowthArr.push([]);
    //     }
    //     ; let BranchNames = [];
    let allmember = _get(state, 'member.getMemberBranch', []);
    let allmemberArr = [];
    if (!_isEmpty(allmember)) {
        allmember.map((data, index) => {
            allmemberArr.push(_get(data, 'branchId', ''));
        })
    }
    else {
        allmemberArr.push([]);
    }
    // let BranchNames = [];
    // let BranchNameprops = _get(state, 'member.getMemberBranch', []);
    // BranchNameprops && BranchNameprops.map(( vname, index )=>{
    //     let BranchNameObj = {
    //         key: index,
    //         text: vname.branchId + "--" + vname.branchName,
    //         value: vname.branchId
    //     }
    //     BranchNames.push(BranchNameObj)
    // })
    // BranchNames.unshift({text:"All Branch summary", value:allmemberArr});

    // chartData1Arr.unshift('data1');
    return {
        allmemberArr1: allmemberArr,
        // BranchNameList: BranchNames,
        // membergrowthlist: membergrowthArr,
        getVerifiedRebateTrendsGraph: {
            chartData1: chartData1Arr,
            chartData2: chartData2Arr,
            chartData3: chartData3Arr
        },
        getCardsDataForIMARKVerifiedDataTab: _get(state, 'member.getCardsDataForIMARKVerifiedDataTab', []),
        getbHverifiedVendorPartnerPurchases: _get(state, 'member.getbHverifiedVendorPartnerPurchases', []),
        isFetching: _get(state, 'member.isFetching', true),
        rebateEstimatesCardsData: _get(state, 'member.rebateEstimatesCardsData', []),
        memberIdForCorporate: _get(sessionStorage, 'imark-memberId', ''),
        //memberIdForCorporate1:  window.sessionStorage.getItem ('imark-memberId'),

        buyingGroupId: _get(sessionStorage, 'imark-buyingGroupId', ''),
        getMemberVerifiedMonthsFilter: _get(state, 'member.getMemberVerifiedMonthsFilter', []),
        getMemberBranch: _get(state, 'member.getMemberBranch', []),
        tabTracking: _get(state, 'corporate.tabTracking', []),

    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVerifiedRebateTrendsGraphAPI: getVerifiedRebateTrendsGraph,
        getbHverifiedVendorPartnerPurchasesAPI: getbHverifiedVendorPartnerPurchases,
        getCardsDataForIMARKVerifiedDataTabAPI: getCardsDataForIMARKVerifiedDataTab,
        getMemberBranchAPI: getMemberBranch,
        getMemberVerifiedMonthsFilterAPI: getMemberVerifiedMonthsFilter,
        tabTrackingAPI:tabTracking,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BHVerifiedData);

